var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"person-image\" ng-style=\"{'background-image':'url(' + $ctrl.person.image + ')'}\" ng-class=\"$ctrl.person.personImageStyle\">\n</div>\n<div class=\"person-name\" ng-if=\"!$ctrl.fullInfo\">\n<span ng-show=\"$ctrl.location\" class=\"person-location-name\">\n{{ $ctrl.location.name }}\n<br>\n</span>\n<span ng-class=\"{'hidden-xs': $ctrl.location}\">\n{{ $ctrl.person.first_name }} {{ $ctrl.person.last_name }}\n</span>\n</div>\n<div class=\"person-details\" ng-if=\"$ctrl.fullInfo\">\n<span class=\"person-details-name\">{{ $ctrl.person.first_name }} {{ $ctrl.person.last_name }}</span>\n<span class=\"person-details-title\">{{ $ctrl.person.title }}</span>\n</div>\n";
var id1="app/common/components/info/person-info.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/info/person-info.tpl.html
// module id = 493
// module chunks = 0